import ServerPath from '../../configs/serverPath';
import SiteMapping from '../../configs/siteMapping';

export const browserItems = [{ name: 'edge' }, { name: 'firefox' }, { name: 'google' }, { name: 'safari' }];

export const footerInfoList = (siteName) => {
    let footerList;
    switch (siteName) {
        case SiteMapping.Nova88:
            footerList = [
                [
                    { i18nKey: 'lbl_AboutUs2', infoPage: 'AboutUs.html', openType: 1 },
                    { i18nKey: 'lbl_Termsofuse', infoPage: 'TermsOfUse.html', openType: 1 },
                    { i18nKey: 'lbl_Termandconditions', infoPage: 'TermsConditions.html', openType: 1 },
                    { i18nKey: 'lbl_FAQ', infoPage: 'FAQ.html', openType: 1 },
                ],
                [
                    { i18nKey: 'lbl_PrivacyPolicy2', infoPage: 'PrivacyPolicy.html', openType: 1 },
                    { i18nKey: 'lbl_PlayerFundsPolicy', infoPage: 'PlayerFunds.html', openType: 1 },
                    { i18nKey: 'lbl_AMLPolicy', infoPage: 'AmlPolicy.html', openType: 1 },
                    { i18nKey: 'lbl_ResponsibleGamingPolicy', infoPage: 'ResponsibleGaming.html', openType: 1 },
                    { i18nKey: 'lbl_ComplaintsAndArbitration', infoPage: 'ComplaintsArbitration.html', openType: 1 },
                ]
            ];
            break;
        default:
            footerList = [
                [
                    { i18nKey: 'lbl_AboutUs', infoPage: 'AboutUs.html', openType: 1 },
                    { i18nKey: 'lbl_ResponsibleGaming', infoPage: 'ResponsibleGaming.html', openType: 1 },
                    { i18nKey: 'lbl_TermsofService', infoPage: 'TermsOfService.html', openType: 1 },
                    { i18nKey: 'lbl_PrivacyPolicy', infoPage: 'PrivacyPolicy.html', openType: 1 },
                    { i18nKey: 'lbl_AccTerms', infoPage: 'AccountTerms.html', openType: 1 },
                ]
            ];
    }

    return footerList;
};
export const InfoPageActionStrategy = {
    OpenStaticPage: 'OpenStaticPage',
    OpenExternalSite: 'OpenExternalSite',
};

export const gotoInfoPageAction = {
    [InfoPageActionStrategy.OpenStaticPage]: (composePath, language, infoPage, isAutoColorSchemeShow) => {
        const landingPage = composePath({
            pathType: isAutoColorSchemeShow ? ServerPath.helpUiHtmlGlobal: ServerPath.helpUiHtml,
            language,
            pathName: infoPage,
        });

        window.open(landingPage, 'infoPage');
    },
    [InfoPageActionStrategy.OpenExternalSite]: (composePath, language, infoPage) => {
        window.open(`${infoPage}/${language}`, 'infoPage');
    },
};

export const DomainWithLicenseList = ['nova88.com', 'nova8866.com', 'nova8877.com', 'nova8888.com', 'nv9891.com', 'nov88.net', '168933.net', '168977.net', '168222.net', '7755778.net'];

export const canNotSeeNovaCasinoDomainList = ['nova88.com'];
